import React, { Component } from 'react';
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
import "./styles.css";
import { HtmlWrapper, fontStyles } from '../../../Utils';
import tr from '../../../libs/tr'

export default class InfoModal extends Component {
  constructor(props) {
    super(props);

    let params = null;
    console.log('[InfoModal]', params);

    this.state = {
      show: this.props.show
    };

  }

  onClose = () => {
    this.setState({ show: false }, () => this.props.onClose());
  }

  render() {
    return (
      <Modal show={this.state.show} onHide={this.onClose}>
        <Modal.Body className="modal-main-body">
          <h5 className="modal-exit" onClick={this.onClose}>
            <span>{(tr.t("Close"))}</span>
          </h5>
          <p className="modal-container">
            {HtmlWrapper(this.props.info)}
          </p>
        </Modal.Body>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/assets/components/Modal/Modal.js